import { START_IR_SIMULATION } from '../actionType';

export const startIRSimulation = (id, params = {}) => ({
  type: START_IR_SIMULATION,
  id,
  verificationId: params.verificationId,
  designId: params.designId,
  IRTableData: params.IRTableData,
  signOffId: params.signOffId
})